/**
 * Read-only structure + editable metadata for a subfield with
 * `hasComponents: true` (TASK-181 WP-C CP-4).
 *
 * Per ADR-0005 D8 the component decomposition (componentType list) is
 * immutable — only label, visibleWhen, placeholder are editable.
 *
 * CZNA-1376 — no width control any more, for the reason CZNA-889 took it off the
 * subfield row: the form stopped using the number. Components used to sit in a
 * Stripes grid as `<Col xs={comp.colSpan || 4}>`; they are now one
 * `label | input` row each, as wide as every other subfield's input. A stored
 * `colSpan` stays valid and is kept on save (see `ComponentDef.colSpan`).
 * The component order is fixed by the renderer's parse/compose logic and
 * is NOT user-rearrangeable (drag-drop omitted intentionally).
 */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextField } from '@folio/stripes/components';
import { readCsLabel, writeCsLabel } from './labelUtils';
var ComponentPropertyEditor = function (_a) {
    var tabIdx = _a.tabIdx, fieldIdx = _a.fieldIdx, subfieldIdx = _a.subfieldIdx, subfieldCode = _a.subfieldCode, components = _a.components, dispatch = _a.dispatch;
    var intl = useIntl();
    var update = function (componentIdx, key, value) {
        dispatch({
            type: 'updateComponentProperty',
            tabIdx: tabIdx,
            fieldIdx: fieldIdx,
            subfieldIdx: subfieldIdx,
            componentIdx: componentIdx,
            key: key,
            value: value,
        });
    };
    return (React.createElement("div", { "data-testid": "component-editor-".concat(subfieldCode), style: { marginTop: '0.5rem', padding: '0.4rem', border: '1px dashed #ccc', borderRadius: '4px' } },
        React.createElement("h5", { style: { marginTop: 0 } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.settings.forms.visual.property.componentsHeading" })),
        components.map(function (comp, idx) {
            var _a, _b, _c, _d;
            return (React.createElement("div", { key: "".concat(comp.componentType, "-").concat(idx), "data-testid": "component-editor-".concat(subfieldCode, "-").concat(idx), style: { marginBottom: '0.4rem' } },
                React.createElement("div", { style: { fontWeight: 'bold', fontFamily: 'monospace' }, "data-testid": "component-editor-".concat(subfieldCode, "-").concat(idx, "-type") }, comp.componentType),
                React.createElement(TextField, { value: readCsLabel(comp.label), onChange: function (e) { return update(idx, 'label', writeCsLabel(comp.label, e.target.value)); }, label: intl.formatMessage({ id: 'ui-czna-authorities.settings.forms.visual.property.componentLabel' }), "data-testid": "component-editor-".concat(subfieldCode, "-").concat(idx, "-label-input") }),
                React.createElement(TextField, { value: (_a = comp.placeholder) !== null && _a !== void 0 ? _a : '', onChange: function (e) { return update(idx, 'placeholder', e.target.value === '' ? undefined : e.target.value); }, label: intl.formatMessage({ id: 'ui-czna-authorities.settings.forms.visual.property.componentPlaceholder' }), "data-testid": "component-editor-".concat(subfieldCode, "-").concat(idx, "-placeholder-input") }),
                React.createElement(TextField, { value: (_d = (_c = (_b = comp.visibleWhen) === null || _b === void 0 ? void 0 : _b.ind1) === null || _c === void 0 ? void 0 : _c.join(',')) !== null && _d !== void 0 ? _d : '', onChange: function (e) {
                        var csv = e.target.value.trim();
                        var ind1List = csv === '' ? undefined : csv.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                        update(idx, 'visibleWhen', ind1List === undefined ? undefined : { ind1: ind1List });
                    }, label: intl.formatMessage({ id: 'ui-czna-authorities.settings.forms.visual.property.componentVisibleWhen' }), "data-testid": "component-editor-".concat(subfieldCode, "-").concat(idx, "-visibleWhen-input") })));
        })));
};
export default ComponentPropertyEditor;
